import types from '../types'

const modeInitialized = (modeId) => ({
  type: types.MODE_INITIALIZED,
  payload: modeId,
})

const outboundTicketSelected = (modeId, ticketID) => ({
  type: types.TICKET_OUTBOUND_SELECTED, payload: { modeId, ticketID },
})
const inboundTicketSelected = (modeId, ticketID) => ({
  type: types.TICKET_INBOUND_SELECTED, payload: { modeId, ticketID },
})
const outboundTicketRemoved = () => ({ type: types.TICKET_OUTBOUND_REMOVED })
const inboundTicketRemoved = () => ({ type: types.TICKET_INBOUND_REMOVED })
const clearResults = () => ({ type: types.TICKET_CLEAR_RESULTS })
const outboundFareClassesChanged = (fareClassNames) => ({
  type: types.OUTBOUND_FARE_CLASS_SELECTED,
  payload: fareClassNames,
})
const inboundFareClassesChanged = (fareClassNames) => ({
  type: types.INBOUND_FARE_CLASS_SELECTED,
  payload: fareClassNames,
})

const boookNowInitated = () => ({
  type: types.BOOK_NOW_INITIATED,
})

const modeChanged = (prevMode, mode) => ({
  type: types.MODE_CHANGED,
  payload: { prevMode, mode },
})

export default {
  modeInitialized,
  outboundTicketSelected,
  inboundTicketSelected,
  inboundTicketRemoved,
  outboundTicketRemoved,
  clearResults,
  outboundFareClassesChanged,
  inboundFareClassesChanged,
  boookNowInitated,
  modeChanged,
}
